/**
 * Workbench 用 query parameter サービス
 * 認証用パラメータなどを除外しつつ、業務画面で引き回す query parameter を一元管理する
 */

import { Injectable } from '@angular/core';

/** Workbench 系画面で保持する query parameter モデル */
export interface WorkbenchQueryParams {
  /** View CD */
  viewcd: number;

  /** アクティブタブ ID */
  tabId: string | null;
}

@Injectable({ providedIn: 'root' })
export class WorkbenchQueryParamsService {
  /**
   * Workbench 系画面で URL に残す業務用 query parameter を構築する
   * 新しい業務パラメータを増やす場合はこのメソッドだけを更新すればよい
   */
  build(viewcd: number, tabId: string | null): WorkbenchQueryParams {
    return {
      viewcd,
      tabId,
    };
  }
}
